import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "GoogleCalendarModule"
const debug = false

export class GoogleCalendarModule extends ModuleProto {

    public accounts         : any[] // org calendars
    public calendars        : any[] // user calendars

    constructor() {
        super(ModuleType.GOOGLE_CALENDAR, {});

        debug && console.log(debug, "constructor() moduleConfig={???}")

        this.name                       = "Google calendar"
        this.description                = "Enable the easy, automatic two way syncronization of all your GoodDay events and milestones with your Google calendar!"
        this.svgIcon                    = "isvg-gcal"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                  = "Integrations"
        this.accounts                   = []
        this.settingsUrl                = "settings/integrations/gcalendar"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.calendars                  = []

        this.canAccess                  = true

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
